import React, {useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {ReadOnlyReviewTable} from '@/components/molecules';

const ReviewProductsTable = ({
  displayedProducts = [],
  isLoading = false,
  hasMoreData = false,
  totalProducts = 0,
  onScroll = () => {},
  containerRef = null,
  itemsPerPage = 10,
  className = ''
}) => {
  const hasData = useMemo(
    () => displayedProducts?.length > 0,
    [displayedProducts]
  );

  const handleScroll = useCallback(
    (event) => {
      if (onScroll) {
        onScroll(event);
      }
    },
    [onScroll]
  );

  if (!hasData) {
    return <></>;
  }

  return (
    <div
      className={`products-table ${className}`}
      data-testid='products-table-container'>
      <div
        ref={containerRef}
        className='table-scroll-container'
        data-testid='table-scroll-container'
        style={{
          maxHeight: '600px',
          overflowY: 'auto',
          overflowX: 'hidden',
          border: '1px solid var(--color-border-default)',
          borderRadius: '8px',
          backgroundColor: 'var(--color-background-layer-01)'
        }}
        onScroll={handleScroll}>
        <ReadOnlyReviewTable products={displayedProducts} className='' />

        {isLoading && (
          <div className='flex justify-center py-4'>
            <div className='text-white'>Loading more products...</div>
          </div>
        )}

        {hasMoreData && !isLoading && (
          <div className='flex justify-center py-4'>
            <div className='text-sm text-gray-400'>
              Showing {displayedProducts?.length} of {totalProducts} products.
              Scroll down to load more.
            </div>
          </div>
        )}

        {!hasMoreData && displayedProducts?.length > itemsPerPage && (
          <div className='flex justify-center py-4'>
            <div className='text-sm text-gray-400'>
              All {totalProducts} products loaded.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

ReviewProductsTable.propTypes = {
  displayedProducts: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  hasMoreData: PropTypes.bool,
  totalProducts: PropTypes.number,
  onScroll: PropTypes.func,
  containerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({current: PropTypes.instanceOf(Element)})
  ]),
  itemsPerPage: PropTypes.number,
  className: PropTypes.string
};

export default React.memo(ReviewProductsTable);
